module.exports = __webpack_public_path__ + "static/lotus-large-369587b250b98bc10b939cadb97b9ed0.png";